var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRequests(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "contact_mail"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_106_3109",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_106_3109)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "contact_mail_2",
    d: "M11.6667 9.16667H17.5V5H11.6667V9.16667ZM14.5833 8.125L12.5 6.66667V5.83333L14.5833 7.29167L16.6667 5.83333V6.66667L14.5833 8.125ZM1.66667 17.5C1.20833 17.5 0.815972 17.3368 0.489583 17.0104C0.163194 16.684 0 16.2917 0 15.8333V4.16667C0 3.70833 0.163194 3.31597 0.489583 2.98958C0.815972 2.66319 1.20833 2.5 1.66667 2.5H18.3333C18.7917 2.5 19.184 2.66319 19.5104 2.98958C19.8368 3.31597 20 3.70833 20 4.16667V15.8333C20 16.2917 19.8368 16.684 19.5104 17.0104C19.184 17.3368 18.7917 17.5 18.3333 17.5H1.66667ZM13.25 15.8333H18.3333V4.16667H1.66667V15.8333H1.75C2.33333 14.7917 3.13889 13.9757 4.16667 13.3854C5.19444 12.7951 6.30556 12.5 7.5 12.5C8.69444 12.5 9.80556 12.7951 10.8333 13.3854C11.8611 13.9757 12.6667 14.7917 13.25 15.8333ZM7.5 11.6667C8.19444 11.6667 8.78472 11.4236 9.27083 10.9375C9.75694 10.4514 10 9.86111 10 9.16667C10 8.47222 9.75694 7.88194 9.27083 7.39583C8.78472 6.90972 8.19444 6.66667 7.5 6.66667C6.80556 6.66667 6.21528 6.90972 5.72917 7.39583C5.24306 7.88194 5 8.47222 5 9.16667C5 9.86111 5.24306 10.4514 5.72917 10.9375C6.21528 11.4236 6.80556 11.6667 7.5 11.6667ZM3.79167 15.8333H11.2083C10.7361 15.3056 10.1771 14.8958 9.53125 14.6042C8.88542 14.3125 8.20833 14.1667 7.5 14.1667C6.79167 14.1667 6.11806 14.3125 5.47917 14.6042C4.84028 14.8958 4.27778 15.3056 3.79167 15.8333ZM7.5 10C7.26389 10 7.06597 9.92014 6.90625 9.76042C6.74653 9.60069 6.66667 9.40278 6.66667 9.16667C6.66667 8.93056 6.74653 8.73264 6.90625 8.57292C7.06597 8.41319 7.26389 8.33333 7.5 8.33333C7.73611 8.33333 7.93403 8.41319 8.09375 8.57292C8.25347 8.73264 8.33333 8.93056 8.33333 9.16667C8.33333 9.40278 8.25347 9.60069 8.09375 9.76042C7.93403 9.92014 7.73611 10 7.5 10Z",
    fill: "url(#paint0_linear_106_3109)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_106_3109",
    x1: 10,
    y1: 2.5,
    x2: 10,
    y2: 17.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.197917,
    stopColor: "#009AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CA5FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequests);
export default __webpack_public_path__ + "static/media/requests.2cd787bd6f6e90f4169d4f35eeec96dd.svg";
export { ForwardRef as ReactComponent };